import React, { useState, useEffect } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';

// Actions
import { addActiveAppointment } from 'src/views/practitioner/Appointment/reducers/actions';
import { setBackUrl, resetBackUrl } from '../../../reducer/commonActions';

// Components
import NoteBlock from '../Table/NoteBlock';
import TimeBlock from '../Table/TimeBlock';
import PatientBlock from '../Table/PatientBlock';

// Constants & Services
import { convertStatusToRowClass } from '../../services/appointmentUI';

// Styles & Images
import { EmptyBlock } from '../Table/tableStyles';
import NoAppointmentsSvg from 'assets/images/no-appointmets.svg';
import s from './MultiSelectTable.style';


const MultiSelectTable = (props) => {
  const { t, appointmentsList, commonFilters, onSelectionChanged, resetTimeStamp, dispatch, backUrl, enablePrevDays } = props;
  const [filterAppointmentsList, setFilterAppointmentsList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);

  useEffect(() => {
    if (onSelectionChanged) onSelectionChanged(selectedList);
  }, [selectedList]);

  const triggerSelection = (id) => {
    let list;
    if (selectedList.includes(id)) {
      list = selectedList.filter(apId => apId !== id);
    } else {
      list = [...selectedList, id];
    }
    setSelectedList(list);
  };

  const triggerGeneralSelector = () => {
    let list = selectedList.length === 0 ? filterAppointmentsList.map(ap => ap.id) : [];
    setSelectedList(list);
  };

  const filteringByCampus = () => {
    const { appointmentsList } = props;
    const { campusId } = commonFilters;

    if (Array.isArray(appointmentsList)) {
      if (campusId) {
        const filterArr = appointmentsList.filter(
          appointment => String(appointment.campus.id) === String(campusId)
        );
        setFilterAppointmentsList(filterArr);
      } else if (!campusId) {
        setFilterAppointmentsList(appointmentsList);
      }
    }
  };

  const goToAppointmentDetails = (appoint) => {
    dispatch(addActiveAppointment(appoint));
    dispatch(setBackUrl({ selectedList: selectedList }));
    dispatch(push(`/practitioner/appointments/${appoint.id}/appointment`));
  };

  useEffect(() => { filteringByCampus(); }, [commonFilters, appointmentsList]);
  useEffect(() => {
    if (filterAppointmentsList.length && backUrl && backUrl.params && backUrl.params.selectedList) {
      setSelectedList(backUrl.params.selectedList);
      dispatch(resetBackUrl());
    } else {
      setSelectedList([]);
    }
  }, [filterAppointmentsList, resetTimeStamp]);

  const isDisableSelection = !appointmentsList ||
    appointmentsList.length === 0 ||
    (
      !enablePrevDays &&
      moment(moment(appointmentsList[0].dateTime).startOf('day')).isBefore(moment().startOf('day'))
    );

  return (
    Array.isArray(filterAppointmentsList) && filterAppointmentsList.length ?

      <s.Table>
        {/* ──── Header ──────────────────────────────────────────────────────────────────────── */}

        <thead>
          <s.TableRow className="table-header">
            <th className="triggers">
              <s.CheckBoxEl
                disabled={isDisableSelection}
                checked={selectedList.length === appointmentsList.length}
                halfChecked={selectedList.length && selectedList.length < appointmentsList.length}
                onClick={triggerGeneralSelector} />
            </th>
            <th className="time">{t('time')}</th>
            <th className="patient" style={{ paddingLeft: '30px', textAlign: 'left' }}>
              {t('patient')}
            </th>
            <th className="ap-type">{t('appointment_type')}</th>
            <th className="note">{t('note')}</th>
          </s.TableRow>
        </thead>

        {/* ──── Body ────────────────────────────────────────────────────────────────────────── */}
        <tbody>
          {filterAppointmentsList.map((appointment) => {
            return (
              <s.TableRow
                disabled={isDisableSelection}
                key={appointment.id}
                className={`${convertStatusToRowClass(appointment)}`}
                active={selectedList.includes(appointment.id)}
              >
                {/* ──── Triggers ───────────────────────────────────────────────────────────── */}
                <td className="triggers">
                  <s.CheckBoxEl
                    onClick={() => { if (!isDisableSelection) triggerSelection(appointment.id); }}
                    checked={selectedList.includes(appointment.id)}
                    disabled={isDisableSelection} />
                </td>

                {/* ──── Appointment time ──────────────────────────────────────────────────── */}
                <td className="time" onClick={() => { goToAppointmentDetails(appointment); }}>
                  <TimeBlock appointment={appointment} />
                </td>

                {/* ──── Patient ───────────────────────────────────────────────────────────── */}
                <td className="patient" onClick={() => { goToAppointmentDetails(appointment); }}>
                  <PatientBlock patient={appointment.patient} />
                </td>

                {/* ──── Appointment type ──────────────────────────────────────────────────── */}
                <td className="ap-type" onClick={() => { goToAppointmentDetails(appointment); }}>
                  <s.CellText>{t(appointment.appointmentType || 'unscheduled')}</s.CellText>
                </td>

                {/* ──── Note ──────────────────────────────────────────────────────────────── */}
                <td className="note" onClick={() => { goToAppointmentDetails(appointment); }}>
                  <NoteBlock note={appointment.note} />
                </td>

              </s.TableRow>
            );
          })}
        </tbody>

      </s.Table>
      :

      <EmptyBlock>
        <div>
          <img src={NoAppointmentsSvg} alt="no appointments"/>
          <p>{t('placeholder_no_appointments')}</p>
        </div>
      </EmptyBlock>
  );
};

const mapStateToProps = state => ({
  commonFilters: state.practitioner.common.commonFilters,
});

export default translate()(
  connect(
    mapStateToProps,
  )(MultiSelectTable)
);
